import defaultConfig from "../configs/default.json";

export const getLikelihoodValues = (config) =>
  Object.entries((config && config.Likelihood) || defaultConfig.config.Likelihood);

export const getLikelihoodName = (score, config) => {
  const likelihood = getLikelihoodValues(config).find((value) => Number(value[0]) === Number(score));
  return likelihood ? likelihood[1] : "";
};
